<h2 class="title">Unpair {{ currentPair.recipient!.enisNumber }} + {{ currentPair.donor.enisNumber }}</h2>

<mat-dialog-content>
  <div class="form-container">
    <form [formGroup]="pairForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="fill">
        <mat-label>Donor</mat-label>
        <mat-select formControlName="donor" [value]="currentPair.donor.id">
          <mat-option [value]="currentPair.donor.id"> {{ currentPair.donor.firstName }} {{ currentPair.donor.lastName }} </mat-option>
          <mat-option *ngFor="let donor of donors" [value]="donor.id"> {{ donor.firstName }} {{ donor.lastName }} </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Recipient</mat-label>
        <mat-select formControlName="recipient" [value]="currentPair.recipient.id">
          <mat-option [value]="currentPair.recipient.id">
            {{ currentPair.recipient.firstName }}
            {{ currentPair.recipient.lastName }}
          </mat-option>
          <mat-option *ngFor="let recipient of recipients" [value]="recipient.id"> {{ recipient.firstName }} {{ recipient.lastName }} </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Relation to Recipient</mat-label>
        <mat-select formControlName="relationToRecipient">
          <mat-option *ngFor="let relation of relations" [value]="relation">
            {{ relation }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments"></textarea>
      </mat-form-field>

      <mat-checkbox formControlName="compatible">Compatible</mat-checkbox>
      <div class="button-container">
        <button mat-button color="warn" type="button" (click)="unpairDonor()">Unpair this pair</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="pairForm.invalid">Submit</button>
      </div>
    </form>
  </div>
</mat-dialog-content>
